import React, { FC, useCallback } from 'react'
import { useSelector } from 'react-redux'

import Button from '@/atoms/Button/Button'
import Modal from '@/atoms/Modal/Modal'
import { Timer } from '@/atoms/Timer/Timer'
import { requestProviderLogout } from '@/lib/auth'
import { getMillisecondsToExpire, setTimerLogout } from '@/lib/auth'
import { useTranslation } from '@/lib/i18n/i18n'
import { AuthActions } from '@/redux/actions'
import { getStore, useDispatch } from '@/redux/stores'
import { ApplicationState } from '@/redux/stores/types'

import { Bolder, ClockIcon, Container, Text } from './SessionTimeoutModal.components'

interface IProps {
	onClose: () => void
}

export const SessionTimeoutModal: FC<IProps> = ({ onClose }) => {
	const auth = useSelector((store: ApplicationState) => store.auth)
	const sessionInfo = auth.get('sessionInfo')
	const getSeconds = useCallback(() => {
		return Math.floor(getMillisecondsToExpire(sessionInfo?.expires_at) / 1000)
	}, [sessionInfo?.expires_at])
	const dispatch = useDispatch()
	const { t } = useTranslation()

	const onConfirm = () => {
		dispatch(AuthActions.updateSession())
		dispatch(AuthActions.hideModal())
		onClose()
	}

	const onLogout = () => {
		requestProviderLogout(getStore())
		onClose()
	}

	const onCancel = () => {
		setTimerLogout(getStore())
		onClose()
	}

	return (
		<Modal
			title={t('session-timeout-modal.title')}
			variant="warning"
			onClose={onClose}
			controlButtons={[
				<Button key="cancel" color="blueOutline" onClick={onLogout}>
					{t('session-timeout-modal.btn-cancel')}
				</Button>,
				<Button key="ok" color="bluePrimary" onClick={onConfirm}>
					{t('session-timeout-modal.btn-ok')}
				</Button>,
			]}
			renderInElement={document.querySelector('#popperContainer')! as HTMLElement}
			zIndex={200000}
		>
			<Container>
				<Text>
					<ClockIcon />
					{t('session-timeout-modal.text')}{' '}
					<Bolder>
						<Timer getSeconds={getSeconds} onFinishTimer={onCancel} />
					</Bolder>
				</Text>
				<Text>{t('session-timeout-modal.confirmation')}</Text>
			</Container>
		</Modal>
	)
}
